<div class="form-horizontal" *ngIf="!isOnlyPreview"
     style=" height: 52px;
             border: 1px solid #aaa;
             border-radius: 5px;
             margin-top: 10px;
             margin-bottom: 10px;
             display: flex;">
  <div class="input-group" style="padding: 8px; width: 40%; min-width: 420px">
    <p-dropdown
        [options]="displayTemplateParameters"
        [(ngModel)]="selectedTemplateParameter"
        styleClass="form-control insert-parameter-dropdown">
      <ng-template let-item pTemplate="item">
        <div *ngIf="item.label.indexOf('hr') === -1">{{item.label}}</div>
        <div *ngIf="item.label.indexOf('hr') !== -1"><hr/></div>
      </ng-template>
    </p-dropdown>
    <button class="btn btn-primary border-left-flat" style="height: 36px; min-width: 160px"
            (click)="addParameter($event)"
            tooltip="This will be replaced at the time of sending the message">
      Insert parameter
    </button>
  </div>
</div>

<div style="display: table-row;">
  <br/>
  <div style="display: table-cell; vertical-align: top;">
    <img src="/img/communications/voiceanalogphone.png" alt="" />
  </div>
  <div style="display: table-cell">
    <div
        style="width: 100%; height: 604px; vertical-align: top; padding-top: 14px; overflow: auto" *ngIf="voiceContent">

      <powernova *ngIf="!isTwilioVoice" [content]="voiceContent"
                 [contextVariables] = "contextVariables$ | async"
                 [updatedModel]="cloneTemplate"
                 [isOnlyPreview]="isOnlyPreview"
                 (selectedNodeChange)="setSelectedIndex($event)"
                 [communicationsCategoryId]="communicationsCategoryId"
      ></powernova>

      <twilio-voice *ngIf="isTwilioVoice" [content]="voiceContent"
                 [contextVariables] = "contextVariables$ | async"
                 [updatedModel]="cloneTemplate"
                 [isOnlyPreview]="isOnlyPreview"
                 (selectedNodeChange)="setSelectedIndex($event)"
                 [communicationsCategoryId]="communicationsCategoryId"
      ></twilio-voice>
    </div>
  </div>
</div>
